import { Box, Skeleton } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { Equipment } from '@app/api/models';
import { FieldView, Txt } from '@app/components/common';
import { useApi } from '@app/hooks';


export const EquipInfo = ({ serialNumber }: { 
  serialNumber: string,
}) => {
  const [equip, setEquip] = useState<Equipment | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const api = useApi();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { data } = await api.equipments.getEquipments({
        filter: {
          serial_num: serialNumber,
        },
        sort: '+id',
        limit: 1,
        offset: 0,
      });
      setEquip(data.data[0]);
      setIsLoading(false);
    })();
  }, [serialNumber]);

  if (!isLoading && !equip) {
    return <Box minH={120}>
      <Skeleton variant="rect" width="100%" height="120px" />
    </Box>;
  }
  return <>
    <Box mt={4} pb={0}>
      <FieldView title='Серийный номер' value={equip?.serial_num} canCopy direction='row' fullWidth />
      <FieldView title='Инвентарный номер' value={equip?.inventory_num} canCopy direction='row' fullWidth />
    </Box>
    <Box mt={2} pb={4}>
      <FieldView title='Модель' value={equip?.model?.name} direction='row' fullWidth />
      <FieldView title='Производитель' value={equip?.manufacturer?.name} direction='row' fullWidth />
      <FieldView title='Бренд' value={equip?.brand?.name} direction='row' fullWidth />
      <FieldView title='Год выпуска' value={equip?.production_date} direction='row' fullWidth />
    </Box>
  </>;
};